/** @typedef {"silent" | "minor" | "major" | "flagship"} FeatureSeverity */

/** @typedef {"unset" | "visual" | "auditory" | "reader" | "experienced"} LearningStyle */

/** @typedef {"explicit" | "inferred"} LearningStyleSource */

/** @typedef {"not_started" | "in_progress" | "completed" | "skipped"} ReleaseEducationStatus */

/** @typedef {"show_me" | "just_tell_me" | "skip"} BriefChoice */

/** @typedef {"visual" | "reader" | "skip"} ChosenExperience */

export const STORAGE_KEY = "cp_product_education_state";
export const SCHEMA_VERSION = 2;

export const LEARNING_STYLES = Object.freeze({
  UNSET: "unset",
  VISUAL: "visual",
  AUDITORY: "auditory",
  READER: "reader",
  EXPERIENCED: "experienced",
});

export const RELEASE_STATUS = Object.freeze({
  NOT_STARTED: "not_started",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
  SKIPPED: "skipped",
});

/** @typedef {"mandatory" | "optional" | "summary" | "silent"} EducationPolicy */

export const EDUCATION_POLICIES = Object.freeze({
  MANDATORY: "mandatory",
  OPTIONAL: "optional",
  SUMMARY: "summary",
  SILENT: "silent",
});

export const DEFAULT_EDUCATION_POLICY = EDUCATION_POLICIES.OPTIONAL;

export const DEFAULT_EDUCATION_SETTINGS = Object.freeze({
  /** Opt-in: do not auto-present release education on login / session restore. */
  autoTourEnabled: false,
  /** Opt-in: Ashley release brief only when auto education runs or user replays it. */
  ashleyBriefEnabled: false,
  ashleyNarrationEnabled: false,
  alwaysShowWhatsNew: false,
  preferSummaries: false,
  /** Opt-in: legacy Driver.js dashboard tour never auto-starts by default. */
  autoFirstTimeGuideEnabled: false,
  learningStyle: LEARNING_STYLES.UNSET,
  learningStyleSource: "explicit",
});

export const LEGACY_DASHBOARD_GUIDE_KEY = "cp_dashboard_guide_seen";
